import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import CircularIndeterminate from '../loadingSpinner.tsx';
import Box from '@mui/material/Box';

export type SortDir = 'asc' | 'desc';

type Props = {
  headers?: any,
  data?: any,
  isLoading?: boolean,
  handleViewItem?: (item: any) => void,
  sortBy?: string | null,
  sortDir?: SortDir | null,
  onSortChange?: (sortBy: string | null, sortDir: SortDir | null) => void,
}

export default function DataTable({
  headers,
  data,
  isLoading,
  handleViewItem,
  sortBy,
  sortDir,
  onSortChange,
}: Props) {
  const handleHeaderClick = (field: string) => {
    if (!onSortChange) return;
    if (sortBy !== field) {
      onSortChange(field, 'desc');
      return;
    }
    if (sortDir === 'desc') {
      onSortChange(field, 'asc');
      return;
    }
    onSortChange(null, null);
  };

  return (
    <TableContainer>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            {headers?.map((el: any, index: number) => {
              const canSort = !!el.sortable && !!onSortChange;
              const active = canSort && sortBy === el.value;
              return (
                <TableCell key={`header-${el.value}-${index}`}>
                  {canSort ? (
                    <TableSortLabel
                      active={active}
                      direction={active ? (sortDir || 'desc') : 'desc'}
                      onClick={() => handleHeaderClick(el.value)}
                    >
                      {el.label}
                    </TableSortLabel>
                  ) : (
                    el.label
                  )}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell colSpan={headers?.length || 7} style={{ textAlign: 'center' }}>
                <Box display="flex" justifyContent="center">
                  <CircularIndeterminate />
                </Box>
              </TableCell>
            </TableRow>
          ) : data?.length > 0 ? (
            data?.map((row: any, idx: number) => {
              return (
                <TableRow
                  key={row.id || row._id || `row-${idx}`}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  onClick={() => handleViewItem && handleViewItem(row)}
                  style={{ cursor: handleViewItem ? 'pointer' : '' }}
                >
                  {headers?.map((el: any, cellIndex: number) => {
                    return (
                      <TableCell key={`cell-${row.id || row._id || idx}-${el.value}-${cellIndex}`}>
                        {row[el.value]}
                      </TableCell>
                    )
                  })}
                </TableRow>
              )
            })
          ) : (
            <TableRow>
              <TableCell colSpan={headers?.length || 7} style={{ textAlign: 'center' }}>
                No data available
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
